export default __webpack_public_path__ + "static/media/bindings_of_the_whispering_blade.395898f7.jpg";